import React from 'react';

interface ProgressBarProps {
  value: number;
}

export const ProgressBar: React.FC<ProgressBarProps> = ({ value }) => {
  const clampedValue = Math.min(Math.max(value, 0), 100);
  const isFull = clampedValue === 100;

  return (
    <div className="h-2 w-full rounded-full bg-neutral-50">
      <div
        className={`h-2 rounded-full transition-all duration-300 ${isFull ? 'bg-green-500' : 'bg-indigo-500'}`}
        style={{ width: `${clampedValue}%` }}
      />
    </div>
  );
};
